import React, { useEffect, useState } from 'react';
import { addClientAccessToProvider, getServiceProvidersList, removeClientAccessFromProvider } from '../../api/serviceProviders';
import DataTable from '../../components/UI/table';
import { PHSHeader } from '../../components/UI/header';
import { styles } from './index.sass';
import { Button, Modal, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getClients } from '../../api';

const { Option } = Select;

export const ServiceProviders = () => {
    const [serviceProviders, setServiceProviders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [clients, setClients] = useState([]);
    const [selectedClientIds, setSelectedClientIds] = useState([]);

    const fetchServiceProviders = async () => {
        setLoading(true);
        const data = await getServiceProvidersList();
        setServiceProviders(data.serviceProviders.map((provider) => {
            const clients = provider.clients || [];
            return {
                ...provider,
                provider_id: provider.id,
                clients: {provider_id: provider.id, clients }
            }
        }) || []);
        setLoading(false);
    }

    const fetchAllClients = async () => {
        const data = await getClients();
        setClients(data.clients || []);
    }

    const onClickAddClient = (id) => {
        setSelectedProvider(id);
    }

    const onClickAddClientAccessToProvider = async () => {
        const data = await addClientAccessToProvider({
            service_provider_id: selectedProvider,
            client_ids: selectedClientIds
        })
        if (data.done) {
            fetchServiceProviders();
        }
        setSelectedProvider(null);
        setSelectedClientIds([]);
    }

    const onClickRemoveClientAccessFromProvider = async (providerId, clientId) => {
        setLoading(true);
        const client = serviceProviders.find(sp => sp.id === providerId).clients.clients.find(c => c.name === clientId);
        const data = await removeClientAccessFromProvider({
            service_provider_id: providerId,
            client_ids: [client.id]
        });
        fetchServiceProviders();
    }

    useEffect(() => {
        fetchServiceProviders();
        fetchAllClients();
    }, []);

    const columns = [
        { title: 'Provider Id', dataIndex: 'provider_id', key: 'provider_id' },
        { title: 'Provider Name', dataIndex: 'provider_name', key: 'provider_name' },
        {
            title: 'Clients', dataIndex: 'clients', key: 'clients',
            width: '70%',
            render: ({clients, provider_id}) => (
                <div className='clients-list'>
                    {clients.map(client => (
                        <div className='client-name' >{client.name} <span className='remove-icon' onClick={() => onClickRemoveClientAccessFromProvider(provider_id, client.name)}>x</span></div>
                    ))}
                </div>
            )
        },
        {
            key: 'actions',
            title: 'Actions',
            render: (text, record) => {
                return (
                    <div>
                        <Button type="default" onClick={() => onClickAddClient(record.id)}>
                            <PlusOutlined />
                        </Button>
                    </div>
                )
            }
        }
    ];

    return (
        <div className={styles}>
            <PHSHeader
                hideBreadCrumb={true}
                hideSubHeader={true}
            />
            <div className='container'>
                <h2>Service Providers</h2>
                <div>
                    <DataTable
                        columns={columns || []}
                        dataSource={serviceProviders || []}
                        loading={loading}
                        hidePagination={true}
                    />
                </div>
                <Modal
                    open={selectedProvider !== null}
                    onCancel={() => setSelectedProvider(null)}
                    onOk={onClickAddClientAccessToProvider}
                >
                    <div>
                        <div>Add Clients to Provider</div>
                        <div>
                            <div>Select Clients</div>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                showSearch
                                defaultValue={[]}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(selectedClients) => {
                                    setSelectedClientIds(selectedClients.map(id => parseInt(id)));
                                }}
                            >
                                {clients.map((client) => {
                                    return (
                                        <Option key={client.id} value={client.id}>{client.full_name}</Option>
                                    )
                                })}
                            </Select>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}